import React, {Component, Fragment} from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import {LIQUIVIDA} from './utilities';

const states = [ { "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, 
{ "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, 
{ "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, 
{ "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, 
{ "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, 
{ "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, 
{ "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, 
{ "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, 
{ "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, 
{ "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, 
{ "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, 
{ "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, 
{ "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" } ]

const dateMask = (value) => {
  var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
  return value = !x[2] ? x[1] : x[1]+ '/' + x[2] + (x[3] ? '/' + x[3] : '')
}

class Liquivida extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lastName: "",
      isValidLastName: "",
      firstName: "",
      isValidFirstName: "",
      dob: "",
      isValidDOB: "",
      gender: "",
      isValidGender: "",
      email: "",
      isValidEmail: "",
      phone: "",
      isValidPhone: "",
      address: "",
      isValidAddress: "",
      city: "",
      isValidCity: "",
      state: "",
      isValidState: "",
      zip: "",
      isValidZip: "",
      isInsured: "",
      isValidInsured: "",
      insuranceName: "",
      isValidInsurance: "",
      policy: "",
      isValidPolicy: "",
      relation: "",
      isValidRelation: "",
      holderName: "",
      isValidHolder: "",
      race: "",
      isValidRace: "",
      ethnicity: "",
      isValidEthnicity: "",
      symptoms: {
        severe: 0,
        mild: 0,
        no: 0
      },
      isValidSymptoms: "",
      exposure: {
        no: 0,
        suspect: 0,
        yes: 0,
      },
      isValidExposure: "",
      category: {
        high: 0,
        low: 0,
      },
      isValidCategory: "",
      isHigh: false,
      isLow: false,
      psc: window.location.href.split('?')[1] ? "PSC2180" : '',
      isValidPSC: "",
      date: "",
      isValidDate: "",
      errors: [],
      busySlots: [],
      submitted: false,
      modal: false,
      loading: false,
      consent: false,
      pcr: true,
      nab: false,
      panel: false,
    }
  }

  onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if(name === "dob"){
      this.setState({
        [name]:dateMask(value)
      })
    } else if (name === 'relation' && value === 'Self'){
      this.setState({
        [name]:value,
        holderName: `${this.state.firstName} ${this.state.lastName}`
      })
    } else {
      this.setState({
        [name]:value
      })
    }
    
  }

  onChangeSymptoms = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.symptoms};
    newSym[key] = value
    this.setState({
      symptoms: newSym
    })
  }

  onChangeExposure = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.exposure};
    newSym[key] = value
    this.setState({
      exposure: newSym
    })
  }

  onChangeTest = (e) => {
    this.setState({
      [e.target.name]: !this.state[e.target.name]
    })
  }

  onChangeRisk = (e) => {
    var key = e.target.getAttribute("name");
    var value = e.target.checked;
    let newSym = {...this.state.category};
    newSym[key] = value
    this.setState({
      category: newSym
    })
  }

  clickHigh = () => {
    this.setState({
      isHigh: !this.state.isHigh
    })
  }

  clickLow = () => {
    this.setState({
      isLow: !this.state.isLow
    })
  }

  submit = () => {
    this.setState({
      loading: true
    })
    let errors = [];
    let isValid = true;
    let newState = {...this.state}
    if (!this.state.firstName){
      isValid = false;
      newState.isValidFirstName = "input-error";
      errors.push('First Name is Required');
    }
    if (!this.state.lastName){
      isValid = false;
      newState.isValidLastName = "input-error";
      errors.push('Last Name is Required')
    }
    if (!this.state.dob){
      isValid = false;
      newState.isValidDOB = "input-error";
      errors.push('Date of Birth is Required')
    }
    if (!this.state.gender){
      isValid = false;
      newState.isValidGender = "input-error";
      errors.push('Gender is Required')
    }
    if (!this.state.email){
      isValid = false;
      newState.isValidEmail = "input-error";
      errors.push('Email is Required')
    }
    if (!this.state.phone){
      isValid = false;
      newState.isValidPhone = "input-error";
      errors.push('Phone is Required')
    }
    if (!this.state.address){
      isValid = false;
      newState.isValidAddress = "input-error";
      errors.push('Address is Required')
    }
    if (!this.state.city){
      isValid = false;
      newState.isValidCity = "input-error";
      errors.push('City is Required')
    }
    if (!this.state.state){
      isValid = false;
      newState.isValidState = "input-error";
      errors.push('State is Required')
    }
    if (!this.state.zip){
      isValid = false;
      newState.isValidZip = "input-error";
      errors.push('Zip Code is Required')
    }
    if (!this.state.isInsured){
      isValid = false;
      newState.isValidInsured = "input-error";
      errors.push('Please indicate if you have an insurance')
    }
    if (this.state.isInsured === 'Yes'){
      if (!this.state.insuranceName){
        isValid = false;
        newState.isValidInsurance = "input-error";
        errors.push('Insurance Name is Required')
      }
      if (!this.state.policy){
        isValid = false;
        newState.isValidPolicy = "input-error";
        errors.push('Policy Number is Required')
      }
      if (!this.state.relation){
        isValid = false;
        newState.isValidRelation = "input-error";
        errors.push('Relation to Insured is Required')
      }
      if (!this.state.holderName){
        isValid = false;
        newState.isValidHolder = "input-error";
        errors.push('Policy Holder Name is Required')
      }
    }
    if (!this.state.race){
      isValid = false;
      newState.isValidRace = "input-error";
      errors.push('Race is Required')
    }
    if (!this.state.ethnicity){
      isValid = false;
      newState.isValidEthnicity = "input-error";
      errors.push('Ethnicity is Required')
    }
    if (this.state.isInsurance){
      if (this.state.isInsurance === '1'){
        if (this.state.policy){
          formData.policy = this.state.policy;
        } else {
          errors.push("Policy is required")
        }
        if (this.state.insurance){
          formData.insurance = this.state.insurance;
        } else {
          errors.push("Insurance Name is required")
        }
        if (this.state.relationToInsured){
          formData.relationToInsured = this.state.relationToInsured;
          if (this.state.relationToInsured === 'Self'){
            formData.guarantor = {
              lastName: this.state.lastName,
              firstName: this.state.firstName,
              dob: this.state.dob,
              address: this.state.address,
              city: this.state.city,
              state: this.state.state,
              zip: this.state.zip,
              phone: this.state.phone,
            }
          } else {
            if (this.state.guarantor.lastName){
              formData.guarantor.lastName = this.state.guarantor.lastName;
            } else {
              errors.push("Guarantor Last Name is required")
            }
        
            if (this.state.guarantor.firstName){
              formData.guarantor.firstName = this.state.guarantor.firstName;
            } else {
              errors.push("Guarantor First Name is required")
            }
        
            if (this.state.guarantor.dob){
              formData.guarantor.dob = this.state.guarantor.dob;
            } else {
              errors.push("Guarantor Date of Birth is required")
            }
        
            if (this.state.guarantor.address){
              formData.guarantor.address = this.state.guarantor.address;
            } else {
              errors.push("Guarantor Address is required")
            }
        
            if (this.state.guarantor.city){
              formData.guarantor.city = this.state.guarantor.city;
            } else {
              errors.push("Guarantor City is required")
            }
        
            if (this.state.guarantor.state){
              formData.guarantor.state = this.state.guarantor.state;
            } else {
              errors.push("Guarantor State is required")
            }
        
            if (this.state.guarantor.zip){
              formData.guarantor.zip = this.state.guarantor.zip;
            } else {
              errors.push("Guarantor Zip is required")
            }
        
            if (this.state.guarantor.phone){
              formData.guarantor.phone = this.state.guarantor.phone;
            } else {
              errors.push("Guarantor Phone is required")
            }
          }
        } else {
          errors.push("Relation to insured is required")
        }
        formData.insuranceID = this.state.insuranceID;
        formData.otherInsuranceInfo = this.state.otherInsuranceInfo;
      }      
    } else {
      errors.push("Are You Insured?")
    }
    if (isValid) {
      let formData = {...this.state};
      formData.dob = moment(this.state.dob, "MM/DD/YYYY").format("YYYY-MM-DD");
      formData.location = PSCS.filter(item => item.code === this.state.psc)[0].address;
      if (window.location.href.split('?')[1]){
        formData.acula = 1;
      } else {
        formData.acula = 0;
      }
      if (this.state.panel){
        formData.test = 'panel'
        if (this.state.nab){
          formData.test = 'panelNab'
        }
      } else {
        if (this.state.pcr){
          formData.test = 'pcr'
          if (this.state.nab){
            formData.test = 'pcrNab'
          }
        } else {
          formData.test = 'nab'
        }
      }
      
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/appointment-liq`,
        data: formData,
      }).then(res => {
        window.location.href = "https://www.empirecitylabs.com/thank-you-for-your-submission/";
      }).catch(err => {
        console.log(err)
      })
    } else {
      newState.errors = errors;
      this.setState(newState)
    }
  }

  back = () => {
    this.setState({
      lastName: "",
      isValidLastName: "",
      firstName: "",
      isValidFirstName: "",
      dob: null,
      isValidDOB: "",
      gender: "",
      isValidGender: "",
      email: "",
      isValidEmail: "",
      phone: "",
      isValidPhone: "",
      address: "",
      isValidAddress: "",
      city: "",
      isValidCity: "",
      state: "",
      isValidState: "",
      zip: "",
      isValidZip: "",
      isInsured: "",
      isValidInsured: "",
      insuranceName: "",
      isValidInsurance: "",
      policy: "",
      isValidPolicy: "",
      relation: "",
      isValidRelation: "",
      holderName: "",
      isValidHolder: "",
      race: "",
      isValidRace: "",
      ethnicity: "",
      isValidEthnicity: "",
      symptoms: {
        severe: 0,
        mild: 0,
        no: 0
      },
      isValidSymptoms: "",
      exposure: {
        no: 0,
        suspect: 0,
        yes: 0,
      },
      isValidExposure: "",
      category: {
        high: 0,
        low: 0,
      },
      isValidCategory: "",
      isHigh: false,
      isLow: false,
      psc: "",
      isValidPSC: "",
      date: null,
      isValidDate: "",
      errors: [],
      busySlots: [],
      submitted: false,
      modal: false,
    })
  }

  onModal = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleConsent = (e) => {
    this.setState({
      consent: !this.state.consent
    })
  }

  renderModal(){
    return(
      <div className={`modal inmodal`} id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" style={{display:"block"}}>
       <div className="modal-dialog modal-lg" role="document">
         <div className="modal-content">
           <div className="modal-header">
             <button type="button" className="close" data-dismiss="modal" onClick={this.onModal}>
               <span aria-hidden="true">x</span>
             </button>
           </div>
           <div className="modal-body modal-reduced-padding"  style={{overflowY: 'auto', height: '500px'}}>
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=17kFXCJos6ID8nDD3hR-HOCpu3kNJcAxP" width="100%" height="100%"></iframe>
           </div>
         </div>
       </div>
     </div>
    )
  }

  consent = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/consent`)
  }

  render() {
    return (
      <div >
        <div >
        {this.state.submitted ?
              <Fragment>
                <div className="row">
                  <div className="col-xs-12 " style={{textAlign: 'center', backgroundColor: '#2a2a2a'}}>
                    <br/><br/>
                    <img className='pull-left' src={LIQUIVIDA} height="40" style={{marginTop: '1%', marginBottom: '1%'}}/>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 " style={{textAlign: 'center'}}>
                    <br/><br/>
                    <h3>Your appointment was scheduled. You should receive an email confirmation shortly.</h3>
                  </div>
                </div> 
                <div className="row">
                  <div className="col-xs-12 " style={{textAlign: 'center'}}>
                    <br/><br/>
                    <button className="btn btn-primary" onClick={this.back}>BACK</button>
                  </div>
                </div>                     
              </Fragment> 
              :
                <Fragment>
                        <div className="row">
                          <div className="col-xs-12 col-sm-12 col-md-10 col-md-offset-1" style={{textAlign: 'center', backgroundColor: '#2a2a2a'}}>
                            <img className='pull-left' src={LIQUIVIDA} height="40" style={{marginTop: '1%', marginBottom: '1%'}}/>
                          </div>
                        </div>
                        <div className="row" style={{textAlign: 'center'}}>
                          <div className="col-xs-12 col-sm-12 col-md-10 col-md-offset-1">
                            <div className="panel-body">
                              <div className="row">
                                <div className="col-xs-12">
                                  <h1 style={{fontWeight: 'bold', color: "#2471A3"}}>*** Book your Housecall visit! ***</h1>
                                  {window.location.href.split('?')[1] === 'florida' ? <h1 style={{fontWeight: 'bold', color: "#2471A3"}} >For 1-Hour PCR Test</h1>: ''}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Last Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidLastName}`} name="lastName" value={this.state.lastName} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>First Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidFirstName}`} name="firstName" value={this.state.firstName} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Date Of Birth<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidDOB}`} placeholder="MM/DD/YYYY" name="dob" value={this.state.dob} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Gender<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidGender}`} name="gender" value={this.state.gender} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Female">Female</option>
                                    <option value="Male">Male</option>
                                    <option value="Prefer not to answer">Prefer not to answer</option>
                                  </select>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Email<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidEmail}`} name="email" value={this.state.email} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Phone<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidPhone}`} name="phone" value={this.state.phone} placeholder="XXXXXXXXXX" onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                  <label>Home Address<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidAddress}`} name="address" value={this.state.address} onChange={this.onChange}/>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>City<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidCity}`} name="city" value={this.state.city} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>State<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidState}`} name="state" value={this.state.state} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    {states.map(item => <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>)}
                                  </select>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Zip<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidZip}`} name="zip" value={this.state.zip} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Are You Insured?<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidInsured}`} name="isInsured" value={this.state.isInsured} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                  </select>
                                </div>
                              </div>
                            {this.state.isInsured === 'Yes' && <div className="row">                          
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Insurance Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidInsurance}`} name="insuranceName" value={this.state.insuranceName} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Policy Member ID<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidPolicy}`} name="policy" value={this.state.policy} onChange={this.onChange}/>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Relation to Insured<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidRelation}`} name="relation" value={this.state.relation} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Self">Self</option>
                                    <option value="Spouse">Spouse</option>
                                    <option value="Child">Child</option>
                                    <option value="Other">Other</option>
                                  </select>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                  <label>Policy Holder Name<span style={{color:"red"}}>*</span></label>
                                  <input className={`form-control input-sm ${this.state.isValidHolder}`} name="holderName" value={this.state.holderName} onChange={this.onChange}/>
                                </div>
                              </div>}
                              <div className="row">
                                <div className="col-xs-6">
                                  <label>Race<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidRace}`} name="race" value={this.state.race} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Black">Black</option>
                                    <option value="White">White</option>
                                    <option value="American Indian/Native American">American Indian/Native American</option>
                                    <option value="Native Hawaiian/Other Pacific Islander">Native Hawaiian/Other Pacific Islander</option>
                                    <option value="Other">Other</option>
                                    <option value="Prefer not to answer">Prefer not to answer</option>
                                  </select>
                                </div>
                                <div className="col-xs-6">
                                  <label>Ethnicity<span style={{color:"red"}}>*</span></label>
                                  <select className={`form-control input-sm ${this.state.isValidEthnicity}`} name="ethnicity" value={this.state.ethnicity} onChange={this.onChange}>
                                    <option value="">Select</option>
                                    <option value="Hispanic/Latino">Hispanic/Latino</option>
                                    <option value="Non-hispanic/Latino">Non-hispanic/Latino</option>
                                    <option value="Prefer not to answer">Prefer not to answer</option>
                                  </select>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12" style={{textAlign: 'left'}}>
                                  <ul style={{color: 'red'}}>
                                    {this.state.errors.map((err, index) => <li style={{float: 'left', margin: '0 10px', width: '200px'}} key={index}>{err}</li>)}
                                  </ul>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xs-12">
                                  <br/>
                                  <button className="btn btn-success btn-block" disabled={this.state.loading} onClick={this.submit}>{this.state.loading ? '...Submitting' : 'Submit an Appointment'}</button>
                                </div>
                              </div>
                            </div>                    
                          </div>
                          {this.state.modal && this.renderModal()}
                        </div>
                      </Fragment>
            }
        </div>
            
            
          </div>
    )
  }
}
export default Liquivida
